module.exports = __webpack_public_path__ + "static/media/ic-powerful-analytics.a74ece2a.svg";